export default __webpack_public_path__ + "static/media/ce-rosetta-db.0113aa6b.png";